import React from 'react';

import BrowseHomePage from 'app/components/browse/BrowseHomePage';
import { fetchBrowseConfig } from 'app/actions/browse/browseHomeActions';
import connectRoute from 'app/routes/connectRoute';

const getRouteData = ({ dispatch }) => {
  return [dispatch(fetchBrowseConfig())];
};

export function BrowseHomePageRoute() {
  return <BrowseHomePage />;
}

export default connectRoute(BrowseHomePageRoute, { getRouteData });
